import * as React from 'react';

import { MuiSnackbar } from '@coursera/cds-core';

/** AI-Generated Documentation - Please Read with Caution */

// Module-level function reference for the singleton pattern
let openSnackbarFn: $TSFixMe;

/**
 * Message type for the snackbar content
 */
type Message = {
  /** Text content to display in the snackbar */
  message: string;
};

/**
 * A singleton snackbar component that provides a centralized notification system.
 * Uses MuiSnackbar internally for the actual UI display.
 */
class UiSnackbar extends React.Component {
  state = {
    open: false,
    message: '',
  };

  componentDidMount() {
    openSnackbarFn = this.openSnackbar;
  }

  /**
   * Opens the snackbar with the specified message
   */
  openSnackbar = ({ message }: Message) => {
    this.setState({
      open: true,
      message,
    });
  };

  /**
   * Handles closing the snackbar
   */
  onClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { message, open } = this.state;
    return <MuiSnackbar message={message} autoHideDuration={3000} open={open} onClose={this.onClose} />;
  }
}

/**
 * Opens the snackbar with the specified message from anywhere in the application
 * @param {Message} options - Object containing the message to display
 */
export function openSnackbar({ message }: Message) {
  openSnackbarFn({ message });
}

export default UiSnackbar;
